/**
 * Sentry User Identification
 *
 * Manages user context in Sentry for correlating errors with users.
 * Uses hashed user IDs for privacy.
 */

import * as Sentry from '@sentry/react';
import { hashUserId } from '../analytics/userProperties';

/**
 * Identify the current user in Sentry.
 * Call this after successful authentication.
 *
 * @param userId - The raw user ID (e.g., Supabase UUID)
 * @param subscriptionPlan - Optional subscription plan for context
 */
export function identifySentryUser(userId: string, subscriptionPlan?: string) {
  Sentry.setUser({
    id: hashUserId(userId),
    // Don't send email or other PII to Sentry
    ...(subscriptionPlan && { subscription_plan: subscriptionPlan }),
  });
}

/**
 * Clear user identity from Sentry.
 * Call this on logout.
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}

/**
 * Set additional user context tags.
 * Useful for filtering errors by user properties.
 */
export function setSentryUserTags(tags: Record<string, string>) {
  Sentry.setTags(tags);
}
